/* eslint-disable react/jsx-key */
import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Column } from 'react-table';
import { stringDateToLocaleString } from 'utils/dateUtils';

import { Table, TableCellChevronRight } from '../generic/Table';
import { DepartmentInfoDto } from '../services/apiGenerated';

export const SimpleDepartmentsTable: React.FC<{
  data: DepartmentInfoDto[] | undefined;
  isLoading: boolean;
  error?: FetchBaseQueryError | SerializedError;
}> = ({ data, isLoading, error }) => {
  const { t } = useTranslation();

  const onRowClick = (row: DepartmentInfoDto) => {
    navigate(`/management/departments/${row.id}`);
  };

  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/ban-types
  const columns: Column<DepartmentInfoDto>[] = [
    {
      Header: t('Afdeling').toString(),
      accessor: 'name',
    },
    {
      Header: t('Medewerkers').toString(),
      accessor: 'employeeCount',
    },
    {
      Header: t('Aantal Rapportages').toString(),
      accessor: 'reportCount',
    },
    {
      Header: t('Laatste wijziging').toString(),
      accessor: (row) => {
        if (!row.lastModifiedDate) {
          return '';
        }
        return stringDateToLocaleString(row.lastModifiedDate);
      },
      sortType: (rowA, rowB) => {
        if (rowA.original.lastModifiedDate === undefined || rowA.original.lastModifiedDate === null) return 0;
        if (rowB.original.lastModifiedDate === undefined || rowB.original.lastModifiedDate === null) return 0;
        if (new Date(rowA.original.lastModifiedDate) > new Date(rowB.original.lastModifiedDate)) return 1;
        if (new Date(rowB.original.lastModifiedDate) > new Date(rowA.original.lastModifiedDate)) return -1;
        return 0;
      },
    },
    // {
    //   Header: t('Actief').toString(),
    //   accessor: (row) => (row.isActive ? TableCellActiveIcon : TableCellInactiveIcon),
    // },
    {
      Header: ' ',
      accessor: () => TableCellChevronRight,
    },
  ];

  return <Table columns={columns} data={data ?? []} onRowClick={onRowClick} isLoading={isLoading} error={error} />;
};
